import React from 'react';
import { func, string } from 'prop-types';
import {
  Button,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalSection,
  Tabs,
  TabsItem,
} from '@axiom/ui';

import { ManageAccountsView } from '../ManageAccountsView/ManageAccountsView';
import { ManageContactsView } from '../ManageContactsView/ManageContactsView';
import { ContactStore } from '../../stores/contact-store';
import { AccountStore } from '../../stores/account-store';

export const ManageClientsModal = ({ contactId, onClose }) => {
  const handleOnTabClick = data => {
    ContactStore.clearState();
    AccountStore.clearState();
  };

  if (contactId) {
    ContactStore.load(contactId);
  }

  return (
    <Modal title="Manage Clients" size="large" name="ManageClientsModal">
      <ModalHeader onClose={onClose}>Manage Clients</ModalHeader>
      <ModalSection>
        <Tabs startTab={contactId ? 'Users' : 'Accounts'}>
          <TabsItem label="Accounts" name="Accounts" onClick={handleOnTabClick}>
            <ManageAccountsView />
          </TabsItem>
          <TabsItem label="Users" name="Users" onClick={handleOnTabClick}>
            <ManageContactsView />
          </TabsItem>
        </Tabs>
      </ModalSection>
      <ModalFooter>
        <Button onClick={onClose}>Close</Button>
      </ModalFooter>
    </Modal>
  );
};

ManageClientsModal.propTypes = {
  contactId: string,
  onClose: func.isRequired,
};
